// MB-I18N-CRM — CRM / Platform EN. Flat keys, namespaces crm.* and platform.*.
export default {
  "platform.brand": "SUPERKAWA® Platform",
  "platform.network_space": "Network space",
  "platform.admin_fallback": "Platform admin",
  "platform.back_os": "Back to OS",
  "platform.tools": "Platform tools",
  "platform.tabs.dossiers": "Records",
  "platform.tabs.priorites": "CRM priorities",
  "platform.tabs.fiabilite": "CRM reliability",
  "platform.tabs.conseiller": "Advisor",
  "platform.tabs.boutiques": "Stores",
  "platform.tabs.whatsapp": "WhatsApp",
  "platform.tabs.programme": "Program",
  "crm.actions.refresh": "Refresh",
  "crm.actions.copy": "Copy",
  "crm.actions.copied": "Copied",
  "crm.actions.save": "Save",
  "crm.actions.cancel": "Cancel",
  "crm.actions.close": "Close",
  "crm.actions.create": "Create",
  "crm.actions.search": "Search",

  "crm.leads.deprecated_title": "Legacy module — deprecated",
  "crm.leads.deprecated_desc": "Client Records are now the single source of truth for the CRM. This screen is kept read-only for existing history purposes only.",
  "crm.leads.title": "Leads ({count})",
  "crm.leads.empty_title": "No leads yet.",
  "crm.leads.empty_hint": "Leads will appear here after the simulator form is submitted.",
  "crm.leads.col_firstname": "First name",
  "crm.leads.col_phone": "Phone",
  "crm.leads.col_country": "Country",
  "crm.leads.col_pack": "Pack",
  "crm.leads.col_qualification": "Qualification",
  "crm.leads.col_date": "Date",
  "crm.leads.col_status": "Status",
  "crm.leads.col_dossier": "Record",
  "crm.leads.status.new": "New",
  "crm.leads.status.contacted": "Contacted",
  "crm.leads.status.qualified": "Qualified",
  "crm.leads.status.lost": "Lost",

  "crm.wa.title": "WhatsApp — Templates & Quick replies",
  "crm.wa.subtitle": "Pre-written messages to copy and paste into your WhatsApp conversations.",
  "crm.wa.grid_title": "Qualification grid",
  "crm.wa.low_desc": "No clear budget, no timeline, vague intent.",
  "crm.wa.low_action": "Action: beginner filter",
  "crm.wa.medium_desc": "Structured project, approximate budget, unclear timeline.",
  "crm.wa.medium_action": "Action: mini estimate",
  "crm.wa.high_desc": "Clear budget, defined timeline, serious intent.",
  "crm.wa.high_action": "Action: transition to offer",
  "crm.wa.flow_title": "Conversion flow",
  "crm.wa.flow.blog_quiz": "Blog / Quiz",
  "crm.wa.flow.whatsapp": "WhatsApp",
  "crm.wa.flow.qualification": "Qualification",
  "crm.wa.flow.mini_estimate": "Mini estimate",
  "crm.wa.flow.offer": "Offer",
  "crm.wa.tpl.default.title": "Default auto-reply",
  "crm.wa.tpl.default.desc": "First message for a direct contact (blog, website)",
  "crm.wa.tpl.default.text": "Hello, thank you for your message.\n\nI can give you a quick estimate for your coffee shop project.\n\nTo move forward, tell me:\n1. City / country?\n2. Approximate budget?\n3. Planned opening (when)?\n4. Do you already have premises or not?",
  "crm.wa.tpl.quiz.title": "Quiz lead / simulator",
  "crm.wa.tpl.quiz.desc": "For contacts coming from the simulator",
  "crm.wa.tpl.quiz.text": "Hello, thank you for your message.\n\nI've seen your simulation.\n\nTo refine your project, tell me:\n1. City / country?\n2. Approximate budget?\n3. Planned opening?\n4. Do you already have premises?",
  "crm.wa.tpl.mini_estimate.title": "Mini estimate (free)",
  "crm.wa.tpl.mini_estimate.desc": "Quick reply after MEDIUM/HIGH qualification",
  "crm.wa.tpl.mini_estimate.text": "With your budget, you can aim for a [simple/mid-range/premium] level coffee shop.\n\nBallpark figures:\n- Equipment: [X]\n- Fit-out: [X]\n- Launch: [X]\n\nThe key point remains the concept and differentiation.",
  "crm.wa.tpl.beginner.title": "Beginner filter",
  "crm.wa.tpl.beginner.desc": "For low-qualified leads (LOW)",
  "crm.wa.tpl.beginner.text": "I advise you to first clarify your project (budget, location, timing).\n\nGet back to me once it's more structured, and I'll be able to give you a precise estimate.",
  "crm.wa.tpl.transition.title": "Transition to offer",
  "crm.wa.tpl.transition.desc": "When the lead is ready to move forward (HIGH)",
  "crm.wa.tpl.transition.text": "If you're moving forward seriously, I can support you across the whole structuring:\n\n- Selecting suitable equipment\n- Standardizing recipes\n- Structuring the concept\n- Launch support\n\nShall we talk?",

  "crm.partner.title": "Partner Program",
  "crm.partner.subtitle": "Internal structure — sales, CRM and commercial proposals use",
  "crm.partner.load_error": "Unable to load the program",
  "crm.partner.matrix_title": "Comparison matrix",
  "crm.partner.section.concept": "1. Concept",
  "crm.partner.section.equipment": "2. Equipment",
  "crm.partner.section.training": "3. Support & training",
  "crm.partner.section.experience": "4. Experience & Branding",
  "crm.partner.section.support": "5. Support & Evolution",
  "crm.partner.row.positioning": "Positioning",
  "crm.partner.row.menu": "Menu",
  "crm.partner.row.differentiator": "Differentiation",
  "crm.partner.row.daily_covers": "Daily customers target",
  "crm.partner.row.coffee_machine": "Espresso machine",
  "crm.partner.row.grinder": "Grinder",
  "crm.partner.essential_setup": "Essential setup",
  "crm.partner.row.level": "Level",
  "crm.partner.row.duration": "Duration",
  "crm.partner.duration_value": "{days} days — {format}",
  "crm.partner.row.signature_recipes": "SUPERKAWA signature recipes included",
  "crm.partner.recipes_value": "{count} recipes ({cats})",
  "crm.partner.training_content": "Training content",
  "crm.partner.row.visual_identity": "Visual identity",
  "crm.partner.row.customer_experience": "Customer experience",
  "crm.partner.row.product_presentation": "Product presentation",
  "crm.partner.row.digital": "Digital",
  "crm.partner.row.onboarding": "Onboarding",
  "crm.partner.row.ongoing_support": "Ongoing support",
  "crm.partner.row.improvements": "Improvements",
  "crm.partner.row.upgrade_path": "Evolution",
  "crm.pipeline.new": "New",
  "crm.pipeline.contacted": "Contacted",
  "crm.pipeline.qualified": "Qualified",
  "crm.pipeline.won": "Won",
  "crm.pipeline.lost": "Lost",
  "crm.pipeline.archived": "Archived",
  "crm.qualification.high": "High",
  "crm.qualification.medium": "Medium",
  "crm.qualification.low": "Low",
  "crm.qualification.unknown": "Unknown",
  "crm.type.prospect": "Prospect",
  "crm.type.client": "Client",
  "crm.type.archived": "Archived",
  "crm.integrity.clean": "Healthy",
  "crm.integrity.review_required": "To review",
  "crm.integrity.ambiguous": "Ambiguous",
  "crm.integrity.conflict": "Conflict",
  "crm.integrity.merged": "Merged",
  "crm.integrity.orphaned": "Orphaned",
  "crm.dossier.fallback_name": "Record",
  "crm.dossier.fallback_name_id": "Record #{id}",
  "crm.completeness.item.identity": "Identity",
  "crm.completeness.item.business_profile": "Business Profile",
  "crm.completeness.item.store": "Store",
  "crm.completeness.item.owner": "Owner",
  "crm.completeness.item.subscription": "Subscription",
  "crm.completeness.item.timeline": "Timeline",
  "crm.completeness.item.commerce": "Commerce",
  "crm.completeness.item.communication": "Communication",
  "crm.completeness.item.support": "Support",
  "crm.due.none": "No due date",
  "crm.due.overdue": "Overdue",
  "crm.due.today": "Today",
  "crm.due.tomorrow": "Tomorrow",
  "crm.due.in_days": "In {days} days",
  "crm.decision.priority.low": "Low",
  "crm.decision.priority.normal": "Normal",
  "crm.decision.priority.high": "High",
  "crm.decision.priority.critical": "Critical",
  "crm.decision.potential.a_confirmer": "To confirm",
  "crm.decision.potential.faible": "Low",
  "crm.decision.potential.modere": "Moderate",
  "crm.decision.potential.eleve": "High",
  "crm.decision.confidence.elevee": "High",
  "crm.decision.confidence.moyenne": "Medium",
  "crm.decision.confidence.faible": "Low",
  "crm.decision.confidence.insuffisante": "Insufficient",
  "crm.decision.family.acquisition": "Acquisition",
  "crm.decision.family.pipeline": "Pipeline",
  "crm.decision.family.commerce": "Commerce",
  "crm.decision.family.communication": "Communication",
  "crm.decision.family.support": "Support",
  "crm.decision.family.produit": "Product",
  "crm.decision.family.integrity": "Integrity",
  "crm.decision.status.acknowledged": "Acknowledged",
  "crm.decision.status.acknowledged_hint": "Seen by the advisor — the signal stays active.",
  "crm.decision.status.dismissed": "Dismissed",
  "crm.decision.status.dismissed_until": "Dismissed until {date}",
  "crm.decision.status.dismissed_hint": "It will reappear after this date if the signal remains true.",
  "crm.decision.status.resolved": "Resolved automatically",
  "crm.decision.status.resolved_hint": "The signal is no longer true — nobody deleted it.",
  "crm.decision.status.expired": "Expired",
  "crm.decision.status.expired_hint": "This signal was no longer relevant beyond its validity period.",
  "crm.decision.chrono.detected": "Detected",
  "crm.decision.chrono.acknowledged": "Acknowledged",
  "crm.decision.chrono.dismissed": "Dismissed",
  "crm.decision.chrono.resolved": "Resolved automatically",
  "crm.decision.chrono.expired": "Expired",
  "crm.decision.not_evaluated": "{count} record(s) never analyzed — analysis starts when the record is opened.",
  "crm.quote.status.draft": "Draft",
  "crm.quote.status.sent": "Sent",
  "crm.quote.status.accepted": "Accepted",
  "crm.quote.status.declined": "Declined",
  "crm.quote.status.expired": "Expired",
  "crm.quote.status.cancelled": "Cancelled",
  "crm.quote.action.sent": "Mark as sent",
  "crm.quote.action.accepted": "Mark as accepted",
  "crm.quote.action.declined": "Mark as declined",
  "crm.quote.action.expired": "Mark as expired",
  "crm.quote.action.cancelled": "Cancel quote",
  "crm.quote.item_type.saas": "SaaS",
  "crm.quote.item_type.hardware_solution": "Hardware solution",
  "crm.quote.item_type.custom": "Custom line",
  "crm.ticket.category.technical_support": "Technical support",
  "crm.ticket.category.billing": "Billing",
  "crm.ticket.category.account": "Account",
  "crm.ticket.category.hardware": "Hardware",
  "crm.ticket.category.training": "Training",
  "crm.ticket.category.feature": "Feature",
  "crm.ticket.category.bug": "Bug",
  "crm.ticket.category.other": "Other",
  "crm.ticket.priority.low": "Low",
  "crm.ticket.priority.normal": "Normal",
  "crm.ticket.priority.high": "High",
  "crm.ticket.priority.critical": "Critical",
  "crm.ticket.status.open": "Open",
  "crm.ticket.status.in_progress": "In progress",
  "crm.ticket.status.waiting": "Waiting",
  "crm.ticket.status.resolved": "Resolved",
  "crm.ticket.status.closed": "Closed",
  "crm.comm.type.email": "Email",
  "crm.comm.type.phone_call": "Call",
  "crm.comm.type.whatsapp": "WhatsApp",
  "crm.comm.type.meeting": "Meeting",
  "crm.comm.type.note": "Note",
  "crm.comm.status.draft": "Draft",
  "crm.comm.status.planned": "Planned",
  "crm.comm.status.completed": "Completed",
  "crm.comm.status.cancelled": "Cancelled",
  "crm.comm.direction.incoming": "Incoming",
  "crm.comm.direction.outgoing": "Outgoing",
  "crm.comm.direction.internal": "Internal",
  "crm.common.loading": "Loading…",
  "crm.actions.open": "Open",
  "crm.actions.refresh_alt": "Refresh",
  "crm.pagination.prev": "Previous",
  "crm.pagination.next": "Next",
  "crm.pagination.page": "Page {page} / {total}",

  "crm.dossiers.title": "Client Records",
  "crm.dossiers.subtitle": "Official CRM entry point · {count} record(s)",
  "crm.dossiers.new_prospect": "New prospect",
  "crm.dossiers.load_error": "Loading error. Please try again.",
  "crm.dossiers.empty": "No record matches the filters.",
  "crm.dossiers.unassigned": "Unassigned",
  "crm.dossiers.col_name": "Name",
  "crm.dossiers.col_type": "Type",
  "crm.dossiers.col_pipeline": "Pipeline",
  "crm.dossiers.col_qualification": "Qualif.",
  "crm.dossiers.col_assignee": "Assignee",
  "crm.dossiers.col_next_action": "Next action",
  "crm.dossiers.col_integrity": "Integrity",
  "crm.dossiers.col_updated": "Updated",
  "crm.dossiers.filter.type_label": "Type",
  "crm.dossiers.filter.type_all": "Type · All",
  "crm.dossiers.filter.pipeline_label": "Pipeline",
  "crm.dossiers.filter.pipeline_all": "Pipeline · All",
  "crm.dossiers.filter.qualification_label": "Qualification",
  "crm.dossiers.filter.qualification_all": "Qualif. · All",
  "crm.dossiers.filter.integrity_label": "Integrity",
  "crm.dossiers.filter.integrity_all": "Integrity · All",
  "crm.dossiers.filter.assignee_label": "Assignee",
  "crm.dossiers.filter.assignee_all": "Assignee · All",
  "crm.dossiers.filter.due_label": "Due date",
  "crm.dossiers.filter.due_all": "Due date · All",
  "crm.dossiers.filter.due_week": "This week",
  "crm.dossiers.filter.due_none": "No action",

  "crm.stores.title": "Stores ({count})",
  "crm.stores.loading": "Loading stores…",
  "crm.stores.empty": "No store yet.",
  "crm.stores.owner": "Owner",
  "crm.stores.not_attached": "Not attached",
  "crm.stores.formule_label": "Plan",
  "crm.stores.formule.libre": "Free",
  "crm.stores.formule.recette": "Recipes",
  "crm.stores.formule.recette_stock": "Recipes + Stock",
  "crm.stores.status.active": "Active",
  "crm.stores.status.trial": "Trial",
  "crm.stores.status.paused": "Suspended",
  "crm.stores.status.cancelled": "Cancelled",
  "crm.stores.suspend": "Suspend",
  "crm.stores.activate": "Activate",
  "crm.stores.manage": "Manage",
  "crm.stores.manage_title": "Open this store in the OS",
  "crm.stores.attach": "Attach",
  "crm.stores.attaching": "Attaching…",
  "crm.stores.attach_title": "Attach me to this store",
  "crm.stores.attach_required": "Attachment required",
  "crm.stores.toast.attach_done": "Attachment completed.",
  "crm.stores.toast.relogin": "Sign in again to enable full management of this store.",
  "crm.stores.toast.attach_error": "Attachment failed.",
  "crm.stores.toast.load_error": "Unable to load the stores.",
  "crm.stores.toast.update_error": "Update failed.",
  "crm.stores.toast.plan_applied": "Plan “{formule}” applied to {store}.",
  "crm.stores.toast.paused": "{store} suspended.",
  "crm.stores.toast.reactivated": "{store} reactivated.",

  "crm.analytics.title": "SUPERKAWA Advisor — Product analytics",
  "crm.analytics.empty": "No analytics data yet.",
  "crm.analytics.days": "{n} days",
  "crm.analytics.one_year": "1 year",
  "crm.analytics.sessions": "Sessions",
  "crm.analytics.leads_conversion": "Leads · conversion {pct}%",
  "crm.analytics.events": "Recorded events",
  "crm.analytics.funnel": "Journey funnel",
  "crm.analytics.abandons": "Drop-offs ({count})",
  "crm.analytics.no_abandon": "No drop-off.",
  "crm.analytics.profiles": "Establishment profiles",
  "crm.analytics.priorities": "Most frequent priorities",
  "crm.analytics.modules": "Most recommended modules",
  "crm.analytics.human_validation": "Human validation required",
  "crm.analytics.human_rate": "{pct}% of recommendations",
  "crm.analytics.avg_time": "Average time",
  "crm.analytics.time_full": "Full journey (up to the recommendation)",
  "crm.analytics.time_to_lead": "Up to the lead",
  "crm.analytics.time_to_abandon": "Up to the drop-off",
  "crm.analytics.conv_by_profile": "Conversion by profile",
  "crm.analytics.conv_by_priority": "Conversion by priority",
  "crm.analytics.footer": "Anonymous product analytics · no personal data, no IP · {days}-day window",
  "crm.analytics.mins_secs": "{m} min {s}s",
  "crm.analytics.secs": "{s}s",
  "crm.analytics.priority.pos": "Checkout",
  "crm.analytics.priority.loyalty": "Loyalty",
  "crm.analytics.priority.margins": "Margins & stock",
  "crm.analytics.priority.qr": "QR payment / menu",
  "crm.analytics.module.pos": "Point of sale (POS)",
  "crm.analytics.module.wallet": "Wallet",
  "crm.analytics.module.loyalty": "Loyalty",
  "crm.analytics.module.qr": "QR payment",
  "crm.analytics.module.recipes": "Recipes",
  "crm.analytics.module.foodcost": "Food cost",
  "crm.analytics.module.stock": "Stock",
  "crm.analytics.module.analytics": "Analytics",
  "crm.analytics.module.multisite": "Multi-site",
  "crm.analytics.module.permissions": "Permissions",
  "crm.analytics.module.orders": "Orders",
  "crm.analytics.module.multicurrency": "Multi-currency",
  "crm.actions.retry": "Retry",
  "crm.age.today": "today",
  "crm.age.days_ago": "{days}d ago",

  "crm.priorities.title": "CRM priorities",
  "crm.priorities.subtitle": "Records to handle first, based on real activity · {count} record(s)",
  "crm.priorities.refreshed": "Priorities refreshed.",
  "crm.priorities.kpi.critical": "Critical records",
  "crm.priorities.kpi.high": "High priority",
  "crm.priorities.kpi.active": "Active actions",
  "crm.priorities.kpi.critical_tickets": "Critical tickets",
  "crm.priorities.kpi.quotes": "Quotes to handle",
  "crm.priorities.filter.priority_label": "Priority",
  "crm.priorities.filter.priority_all": "Priority · All",
  "crm.priorities.filter.family_label": "Family",
  "crm.priorities.filter.family_all": "Family · All",
  "crm.priorities.filter.confidence_label": "Confidence",
  "crm.priorities.filter.confidence_all": "Confidence · All",
  "crm.priorities.filter.status_label": "Status",
  "crm.priorities.filter.status_all": "Status · Active and seen",
  "crm.priorities.filter.status_active": "Active",
  "crm.priorities.filter.status_ack": "Seen",
  "crm.priorities.error": "Unable to load CRM priorities.",
  "crm.priorities.empty_title": "No urgent action detected.",
  "crm.priorities.empty_desc": "The evaluated records currently show no signal requiring special attention.",
  "crm.priorities.col_dossier": "Record",
  "crm.priorities.col_priority": "Priority",
  "crm.priorities.col_action": "Suggested action",
  "crm.priorities.col_family": "Family",
  "crm.priorities.col_confidence": "Confidence",
  "crm.priorities.col_last_activity": "Last activity",
  "crm.priorities.col_age": "Age",
  "crm.priorities.actions_count": "{count} action(s)",
  "crm.priorities.critical_ticket": " · Critical ticket",
  "crm.priorities.quote_action": " · Quote to handle",
  "crm.priorities.advised_action": "Advised action: {label}",
  "crm.priorities.ack": "Acknowledge",
  "crm.priorities.seen": "Acknowledged",
  "crm.priorities.seen_title": "Seen by the advisor — the signal stays active.",
  "crm.priorities.open_dossier": "Open record",
  "crm.priorities.ack_success": "Suggestion acknowledged.",
  "crm.priorities.ack_error": "Unable to acknowledge this suggestion. Please try again.",
  "crm.priorities.critical_pin": "{count} critical record(s)",

  "crm.reliability.title": "CRM reliability",
  "crm.reliability.subtitle": "Real usage and quality of CRM suggestions — read only",
  "crm.reliability.refreshed": "Metrics refreshed.",
  "crm.reliability.period.7d": "7 days",
  "crm.reliability.period.30d": "30 days",
  "crm.reliability.period.90d": "90 days",
  "crm.reliability.period.all": "All",
  "crm.reliability.error": "Unable to load reliability metrics.",
  "crm.reliability.empty_title": "Not enough data to compute the metrics.",
  "crm.reliability.empty_desc": "Indicators will appear as soon as records have been analyzed.",
  "crm.reliability.health.healthy": "No significant anomaly detected.",
  "crm.reliability.health.warning": "Some decisions require a review.",
  "crm.reliability.health.critical": "Significant anomalies require a quick review.",
  "crm.reliability.kpi.evaluated": "Analyzed records",
  "crm.reliability.kpi.coverage": "Analysis coverage",
  "crm.reliability.kpi.active": "Active actions",
  "crm.reliability.kpi.ack": "Acknowledged",
  "crm.reliability.kpi.resolved": "Resolved automatically",
  "crm.reliability.kpi.anomalies": "Reliability alerts",
  "crm.reliability.day_abbr": "d",
  "crm.reliability.median": "(median {v})",
  "crm.reliability.delay_ack": "Average time before acknowledgment",
  "crm.reliability.delay_resolve": "Average time before resolution",
  "crm.reliability.rules_title": "Most active rules",
  "crm.reliability.rules_empty": "No suggestion issued during this period.",
  "crm.reliability.col_rule": "Rule",
  "crm.reliability.col_family": "Family",
  "crm.reliability.col_decisions": "Decisions",
  "crm.reliability.col_ack": "Acknowledged",
  "crm.reliability.col_dismissed": "Dismissed",
  "crm.reliability.col_resolved": "Resolved",
  "crm.reliability.quality_title": "Data quality",
  "crm.reliability.decisions_checked": "{count} decision(s) checked",
  "crm.reliability.quality_ok": "No inconsistency detected in the recorded suggestions.",
  "crm.actions.change": "Change",
  "crm.actions.associate": "Associate",
  "crm.actions.back": "Back",
  "crm.subscription.title": "Subscription",
  "crm.subscription.plan_label": "Plan",
  "crm.subscription.status_label": "Status",
  "crm.subscription.store_label": "Store",
  "crm.subscription.empty": "No subscription.",
  "crm.subscription.plan.libre": "Free",
  "crm.subscription.plan.recettes": "Recipes",
  "crm.subscription.plan.recettes_stock": "Recipes + Stock",
  "crm.subscription.status.active": "Active",
  "crm.subscription.status.trial": "Trial",
  "crm.subscription.status.past_due": "Past due",
  "crm.subscription.status.cancelled": "Cancelled",
  "crm.subscription.status.paused": "Suspended",
  "crm.identity.title": "Identity",
  "crm.identity.name": "Name",
  "crm.identity.company": "Company",
  "crm.identity.type": "Type",
  "crm.identity.crm_status": "CRM status",
  "crm.identity.qualification": "Qualification",
  "crm.identity.assignee": "Assignee",
  "crm.identity.id": "Identifier",
  "crm.identity.created": "Created on",
  "crm.identity.updated": "Updated on",
  "crm.completeness.title": "Completeness",
  "crm.breadcrumb.aria": "Breadcrumb",
  "crm.integrity.title": "Integrity",
  "crm.integrity.stat_links": "Links",
  "crm.integrity.stat_references": "References",
  "crm.integrity.stat_unresolved": "Unresolved",
  "crm.dossier_error.404_title": "Record not found",
  "crm.dossier_error.404_msg": "This client record does not exist or has been merged.",
  "crm.dossier_error.403_title": "Access denied",
  "crm.dossier_error.403_msg": "You must be a platform administrator to view this record.",
  "crm.dossier_error.generic_title": "An error occurred",
  "crm.dossier_error.generic_msg": "Unable to load the client record. Please try again later.",
  "crm.header.pipeline_prefix": "Pipeline · {label}",
  "crm.header.qualif_prefix": "Qualif. · {label}",
  "crm.header.score": "CRM score",
  "crm.business.title": "Business Profile",
  "crm.business.legal_name": "Legal name",
  "crm.business.country": "Country",
  "crm.business.currency": "Currency",
  "crm.business.registration": "Registration no.",
  "crm.business.vat": "VAT identifier",
  "crm.business.empty": "No Business Profile linked.",
  "crm.owner.title": "Owner",
  "crm.owner.empty": "No owner linked.",
  "crm.owner.account_disabled": "Account disabled",
  "crm.owner.account_active": "Account active",
  "crm.owner.registered_on": "registered on {date}",
  "crm.owner.shops": "{count} store(s)",
  "crm.open_dossier.label": "Open Client Record",
  "crm.open_dossier.searching": "Looking up the record…",
  "crm.open_dossier.unavailable": "Client Record unavailable",
  "crm.unlink.trigger": "Remove",
  "crm.unlink.trigger_title": "Remove link",
  "crm.unlink.title": "Remove link?",
  "crm.unlink.desc_named": "“{label}” will no longer be referenced by this CRM record. The object itself is neither deleted nor modified (no product, tenant or access impact).",
  "crm.unlink.desc_generic": "This item will no longer be referenced by this CRM record. The object itself is neither deleted nor modified (no product, tenant or access impact).",
  "crm.unlink.confirm": "Remove link",
  "crm.unlink.toast_success": "Link removed.",
  "crm.unlink.toast_error": "Removal failed. Please try again.",
  "crm.convert.btn": "Convert to client",
  "crm.convert.confirm_title": "Convert to client?",
  "crm.convert.confirm_desc": "This operation permanently turns this prospect into a client. It does not create any store, subscription or user.",
  "crm.convert.submit": "Convert",
  "crm.convert.force_title": "No client signal detected",
  "crm.convert.force_desc": "This prospect does not yet have any element indicating it has become a client.",
  "crm.convert.force_submit": "Confirm anyway",
  "crm.convert.toast_success": "The prospect is now a client.",
  "crm.convert.toast_already": "This record is already a client.",
  "crm.convert.toast_error": "Conversion failed. Please try again.",
  "crm.link.warning.store_without_owner": "Store linked without an owner.",
  "crm.link.warning.owner_store_mismatch": "The linked owner does not match any linked store.",
  "crm.link.warning.business_profile_identity_mismatch": "The Business Profile identity seems distinct from the record.",
  "crm.link.picker.business.title": "Link a Business Profile",
  "crm.link.picker.business.desc": "Select an existing profile. No data is copied: the record keeps a simple reference.",
  "crm.link.picker.store.title": "Link a store",
  "crm.link.picker.store.desc": "Select an existing store. The tenant is never modified: the record keeps a simple reference.",
  "crm.link.picker.owner.title": "Link an owner",
  "crm.link.picker.owner.desc": "Select an existing owner account. No role or access is modified: the record keeps a simple reference.",
  "crm.link.search_placeholder": "Search…",
  "crm.link.searching": "Searching…",
  "crm.link.load_error": "Unable to load the results. Please try again.",
  "crm.link.no_results": "No results.",
  "crm.link.already_linked": "This item is already linked to the record.",
  "crm.link.linked": "Link saved.",
  "crm.link.replaced": "Link replaced.",
  "crm.link.warning_generic": "Integrity warning detected.",
  "crm.link.assoc_error": "Linking failed. Please try again.",
  "crm.link.replace_prompt": "A link already exists for this record. Do you want to replace it with “{label}”? The currently linked object will not be deleted: only the CRM reference changes.",
  "crm.link.replace_confirm": "Replace link",
  "crm.search.aria": "Universal CRM search",
  "crm.search.placeholder": "Search a name, a company, an email, a phone, a quote or a ticket…",
  "crm.search.error": "Search error. Please try again.",
  "crm.search.empty": "No record found for “{term}”.",
  "crm.search.no_contact": "No contact details",
  "crm.search.via": "via {list}",
  "crm.stores_card.associate": "Link a store",
  "crm.stores_card.empty": "No store linked.",
  "crm.stores_card.fallback_name": "Store",
  "crm.stores_card.owner_prefix": "Owner: {list}",
  "crm.stores_card.warning_count": "({count} stores)",
  "crm.pipeline.title": "Pipeline & Qualification",
  "crm.pipeline.saving": "Saving…",
  "crm.pipeline.status_label": "Status (pipeline)",
  "crm.pipeline.qualif_label": "Qualification",
  "crm.pipeline.assignee_label": "Assignee",
  "crm.pipeline.assignee_ph": "Owner name",
  "crm.pipeline.score_label": "CRM score (0–100)",
  "crm.pipeline.next_action_label": "Next action",
  "crm.pipeline.next_action_ph": "e.g. call the client back",
  "crm.pipeline.due_label": "Due date",
  "crm.pipeline.notes_label": "Internal notes",
  "crm.pipeline.notes_ph": "Commercial context, exchange history…",
  "crm.pipeline.score_error": "The score must be between 0 and 100.",
  "crm.pipeline.save_success": "Commercial state saved.",
  "crm.pipeline.save_error": "Save failed. Please try again.",
  "crm.breadcrumb.cockpit": "Cockpit",
  "crm.breadcrumb.crm": "CRM",
  "crm.breadcrumb.dossier": "Client Record",
  "crm.commerce.title": "Commerce",
  "crm.commerce.create_quote": "Create a quote",
  "crm.commerce.stat_quotes": "Quotes",
  "crm.commerce.stat_last": "Last quote",
  "crm.commerce.history": "Quote history",
  "crm.commerce.valid_until": "valid until {date}",
  "crm.commerce.empty": "No quote for this record.",
  "crm.support.title": "Support",
  "crm.support.new_ticket": "New ticket",
  "crm.support.stat_tickets": "Tickets",
  "crm.support.stat_open": "Open",
  "crm.support.stat_last": "Last ticket",
  "crm.support.history": "Ticket history",
  "crm.support.search_ph": "Number, title, assignee, tag…",
  "crm.support.empty_search": "No ticket matches the search.",
  "crm.support.empty": "No ticket for this record.",
  "crm.support.load_more": "Load more ({count}/{total})",
  "crm.comm_card.title": "Communication",
  "crm.comm_card.new": "New interaction",
  "crm.comm_card.stat_interactions": "Interactions",
  "crm.comm_card.stat_last": "Last exchange",
  "crm.comm_card.history": "Communication history",
  "crm.comm_card.search_ph": "Subject, summary, participant…",
  "crm.comm_card.empty_search": "No interaction matches the search.",
  "crm.comm_card.empty": "No interaction for this record.",
  "crm.history.created": "Created",
  "crm.history.updated": "Updated",
  "crm.history.deleted": "Deleted",
  "crm.comm_detail.load_error": "Unable to load the interaction.",
  "crm.comm_detail.fallback": "Interaction",
  "crm.comm_detail.desc": "Relationship history — read only.",
  "crm.comm_detail.type": "Type",
  "crm.comm_detail.direction": "Direction",
  "crm.comm_detail.occurred": "Exchange date",
  "crm.comm_detail.duration": "Duration:",
  "crm.comm_detail.minutes": "{min} min",
  "crm.comm_detail.outcome": "Outcome:",
  "crm.comm_detail.attachments": "Attachments:",
  "crm.comm_detail.logged_by": "Logged by",
  "crm.comm_detail.on": "on {date}",
  "crm.comm_detail.participants": "Participants",
  "crm.comm_detail.summary": "Summary",
  "crm.comm_detail.content": "Content",
  "crm.comm_detail.history": "History",
  "crm.ticket_create.title": "New ticket",
  "crm.ticket_create.desc": "Support request linked to the record — opened with status “Open”.",
  "crm.ticket_create.title_label": "Title",
  "crm.ticket_create.title_ph": "Request summary",
  "crm.ticket_create.desc_label": "Description",
  "crm.ticket_create.desc_ph": "Details of the support request",
  "crm.ticket_create.category": "Category",
  "crm.ticket_create.priority": "Priority",
  "crm.ticket_create.assignee": "Assigned to",
  "crm.ticket_create.assignee_ph": "e.g. Taha",
  "crm.ticket_create.due": "Due date",
  "crm.ticket_create.tags": "Tags (comma-separated)",
  "crm.ticket_create.tags_ph": "e.g. urgent, checkout, training",
  "crm.ticket_create.submit": "Open ticket",
  "crm.ticket_create.title_required": "Title required.",
  "crm.ticket_create.created": "Ticket opened.",
  "crm.ticket_create.create_error": "Unable to create the ticket.",
  "crm.ticket_create.create_error_detail": "Creation failed: {detail}",
  "crm.history.status_changed": "Status change",
  "crm.history.assigned": "Assignment",
  "crm.quote_create.title": "Create a quote",
  "crm.quote_create.desc": "Commercial proposal (V1): the quote is created as a draft. No signature or payment.",
  "crm.quote_create.label_required": "Each line must have a label.",
  "crm.quote_create.created": "Quote {number} created (draft).",
  "crm.quote_create.error": "Unable to create the quote.",
  "crm.quote_create.error_detail": "Creation failed: {detail}",
  "crm.quote_create.remove_line": "Remove line",
  "crm.quote_create.hardware_ph": "e.g. Essential hardware solution",
  "crm.quote_create.line_label_ph": "Line label",
  "crm.quote_create.description_ph": "Description (optional)",
  "crm.quote_create.qty": "Quantity",
  "crm.quote_create.unit_price": "Unit price",
  "crm.quote_create.discount": "Discount",
  "crm.quote_create.line_total": "Line total",
  "crm.quote_create.add_line": "Add a line",
  "crm.quote_create.currency": "Currency",
  "crm.quote_create.tax": "VAT (%)",
  "crm.quote_create.valid_until": "Valid until",
  "crm.quote_create.notes_ph": "Internal notes (optional)",
  "crm.quote_create.subtotal": "Subtotal:",
  "crm.quote_create.tax_label": "VAT:",
  "crm.quote_create.submit": "Create the quote",
  "crm.quote_detail.title": "Quote {number}",
  "crm.quote_detail.fallback": "Quote",
  "crm.quote_detail.desc": "Commercial proposal — reading and status tracking.",
  "crm.quote_detail.pdf_error": "Unable to generate the PDF.",
  "crm.quote_detail.load_error": "Unable to load the quote.",
  "crm.quote_detail.status_changed": "Quote {number}: {status}.",
  "crm.quote_detail.status_error": "Unable to change the status.",
  "crm.quote_detail.preview": "Preview",
  "crm.quote_detail.download": "Download PDF",
  "crm.quote_detail.print": "Print",
  "crm.quote_detail.total_label": "Total amount",
  "crm.quote_detail.valid_until": "Valid until",
  "crm.quote_detail.created": "Created on",
  "crm.quote_detail.lines": "Lines",
  "crm.quote_detail.discount": "discount {amount}",
  "crm.quote_detail.subtotal": "Subtotal:",
  "crm.quote_detail.tax": "VAT:",
  "crm.quote_detail.total_inline": "Total:",
  "crm.quote_detail.notes": "Notes",
  "crm.quote_detail.history": "History",
  "crm.comm_create.title": "New interaction",
  "crm.comm_create.desc": "Relationship history (V1): the exchange is logged, nothing is sent.",
  "crm.comm_create.subject_note": "Title",
  "crm.comm_create.subject_meeting": "Meeting subject",
  "crm.comm_create.subject_default": "Subject",
  "crm.comm_create.subject_required": "{field} is required.",
  "crm.comm_create.subject_ph_note": "Title of the exchange note",
  "crm.comm_create.subject_ph_default": "Exchange subject",
  "crm.comm_create.created": "Interaction logged.",
  "crm.comm_create.error": "Unable to save the interaction.",
  "crm.comm_create.error_detail": "Save failed: {detail}",
  "crm.comm_create.status": "Status",
  "crm.comm_create.direction": "Direction",
  "crm.comm_create.occurred": "Exchange date",
  "crm.comm_create.duration": "Duration (minutes)",
  "crm.comm_create.attachments": "Attachments (count)",
  "crm.comm_create.participants": "Participants (comma-separated)",
  "crm.comm_create.participants_ph": "e.g. Taha, contact@client.com",
  "crm.comm_create.summary": "Summary",
  "crm.comm_create.summary_ph": "Summary of the exchange",
  "crm.comm_create.content": "Content",
  "crm.comm_create.content_ph": "Detailed content of the note",
  "crm.comm_create.outcome": "Outcome",
  "crm.comm_create.outcome_ph": "e.g. Follow-up planned, quote to send…",
  "crm.comm_create.submit": "Log the interaction",
  "crm.ticket_detail.fallback": "Ticket",
  "crm.ticket_detail.desc": "Support ticket — single reference for assistance requests.",
  "crm.ticket_detail.load_error": "Unable to load the ticket.",
  "crm.ticket_detail.unassigned": "unassigned",
  "crm.ticket_detail.title_required": "Title required.",
  "crm.ticket_detail.updated": "Ticket updated.",
  "crm.ticket_detail.update_error": "Unable to update the ticket.",
  "crm.ticket_detail.update_error_detail": "Update failed: {detail}",
  "crm.ticket_detail.status_changed": "Status: {status}.",
  "crm.ticket_detail.transition_forbidden": "Forbidden transition.",
  "crm.ticket_detail.status_error": "Unable to change the status.",
  "crm.ticket_detail.category": "Category",
  "crm.ticket_detail.priority": "Priority",
  "crm.ticket_detail.assignee": "Assigned to",
  "crm.ticket_detail.created_on": "Created on",
  "crm.ticket_detail.due": "Due date:",
  "crm.ticket_detail.closed_on": "Closed on",
  "crm.ticket_detail.description": "Description",
  "crm.ticket_detail.tags": "Tags",
  "crm.ticket_detail.transitions": "Transitions",
  "crm.ticket_detail.history": "History",
  "crm.ticket_detail.edit": "Edit",
  "crm.timeline.title": "Timeline",
  "crm.timeline.subtitle": "Chronological history of the record",
  "crm.timeline.count_one": "{count} event",
  "crm.timeline.count_other": "{count} events",
  "crm.timeline.filters_aria": "Timeline filters",
  "crm.timeline.loading_aria": "Loading the timeline",
  "crm.timeline.error": "Unable to load the timeline.",
  "crm.timeline.empty_1": "No events yet.",
  "crm.timeline.empty_2": "Future actions related to this record will appear here.",
  "crm.timeline.filter_empty": "No events loaded for this filter.",
  "crm.timeline.loading_more": "Loading…",
  "crm.timeline.load_more": "Load more",
  "crm.timeline.load_more_aria": "Load more events",
  "crm.timeline.unknown_date": "Unknown date",
  "crm.timeline.today": "Today",
  "crm.timeline.yesterday": "Yesterday",
  "crm.timeline.important": "Important",
  "crm.timeline.critical": "Critical",
  "crm.timeline.family.identity": "Identity",
  "crm.timeline.family.acquisition": "Acquisition",
  "crm.timeline.family.crm": "CRM",
  "crm.timeline.family.product": "Product",
  "crm.timeline.family.commerce": "Commerce",
  "crm.timeline.family.communication": "Communication",
  "crm.timeline.family.support": "Support",
  "crm.timeline.family.decision": "Decision",
  "crm.timeline.family.system": "System",
  "crm.timeline.filter.all": "All",
  "crm.timeline.filter.crm": "CRM",
  "crm.timeline.filter.acquisition": "Acquisition",
  "crm.timeline.filter.commerce": "Commerce",
  "crm.timeline.filter.communication": "Communication",
  "crm.timeline.filter.support": "Support",
  "crm.timeline.filter.decision": "Decisions",
  "crm.timeline.filter.product": "Product",
  "crm.timeline.filter.system": "System",

  "crm.decision.card_title": "Suggested actions",
  "crm.decision.refresh_analysis": "Refresh analysis",
  "crm.decision.subtitle": "Priorities detected from the record's activity",
  "crm.decision.last_analysis": "— last analysis: {time}",
  "crm.decision.error": "Unable to load suggested actions right now.",
  "crm.decision.synth.priority": "Priority",
  "crm.decision.synth.potential": "Potential",
  "crm.decision.synth.confidence": "Confidence",
  "crm.decision.confidence_badge": "Confidence: {level}",
  "crm.decision.limited_title": "Limited analysis",
  "crm.decision.limited_desc": "Some record information is insufficient to produce reliable recommendations.",
  "crm.decision.empty_title": "No urgent action detected.",
  "crm.decision.empty_desc": "The record currently shows no signal requiring particular attention.",
  "crm.decision.same_action": "Same recommended action as above.",
  "crm.decision.suggested_action": "Recommended action: {label}",
  "crm.decision.suggestion_count_title": "{count} suggestions propose this same action",
  "crm.decision.acknowledge": "Acknowledge",
  "crm.decision.dismiss": "Dismiss",
  "crm.decision.history": "History",
  "crm.decision.reason_prefix": "Reason: {reason}",
  "crm.decision.show_all": "Show all ({count})",
  "crm.decision.collapse": "Collapse",
  "crm.decision.history_section": "Suggestion history",
  "crm.decision.history_empty": "No past suggestions for this record — nothing has been dismissed or resolved yet.",
  "crm.decision.toast_refreshed": "Analysis refreshed.",
  "crm.decision.toast_acknowledged": "Suggestion acknowledged.",
  "crm.decision.toast_ack_error": "Unable to acknowledge this suggestion. Try again.",
  "crm.decision.toast_history_error": "Unable to load history. Try again.",
  "crm.decision.toast_dismissed_until": "Suggestion dismissed until {date}.",
  "crm.decision.toast_dismissed_30": "Suggestion dismissed for 30 days.",
  "crm.decision.toast_dismiss_error": "Unable to dismiss this suggestion. Try again.",
  "crm.decision.dismiss_dialog_title": "Dismiss this suggestion for 30 days?",
  "crm.decision.dismiss_dialog_desc": "It will be hidden until {date} and may reappear afterwards if the signal remains true. No record object is modified.",
  "crm.decision.dismiss_reason_ph": "Short reason (optional)",
  "crm.decision.dismiss_busy": "In progress…",
  "crm.decision.dismiss_confirm": "Dismiss for 30 days",

  "crm.manual_prospect.title": "New prospect",
  "crm.manual_prospect.desc": "Contact met outside public forms (call, trade show, field…). An official client record is created immediately.",
  "crm.manual_prospect.origin.inbound_call": "Inbound call",
  "crm.manual_prospect.origin.trade_show": "Trade show",
  "crm.manual_prospect.origin.referral": "Referral",
  "crm.manual_prospect.origin.field": "Field",
  "crm.manual_prospect.origin.whatsapp": "WhatsApp",
  "crm.manual_prospect.origin.partner": "Partner",
  "crm.manual_prospect.origin.other": "Other",
  "crm.manual_prospect.contact.email": "Email",
  "crm.manual_prospect.contact.phone": "Phone",
  "crm.manual_prospect.contact.whatsapp": "WhatsApp",
  "crm.manual_prospect.match.email": "same email",
  "crm.manual_prospect.match.phone": "same phone",
  "crm.manual_prospect.match.email_phone": "same email and phone",
  "crm.manual_prospect.dup_title": "A record already exists for this contact.",
  "crm.manual_prospect.dup_desc": "Match detected: {match}. No record was created.",
  "crm.manual_prospect.conflict_title": "The email and phone match two different records.",
  "crm.manual_prospect.conflict_desc": "No record was created. Check the existing records before continuing.",
  "crm.manual_prospect.field.first_name": "First name",
  "crm.manual_prospect.field.last_name": "Last name",
  "crm.manual_prospect.field.company": "Company",
  "crm.manual_prospect.field.country": "Country (code)",
  "crm.manual_prospect.field.email": "Email",
  "crm.manual_prospect.field.phone": "Phone",
  "crm.manual_prospect.field.origin": "Contact source",
  "crm.manual_prospect.field.source_detail": "Source detail",
  "crm.manual_prospect.field.preferred_contact": "Preferred channel",
  "crm.manual_prospect.field.qualification": "Initial qualification",
  "crm.manual_prospect.field.assignee": "Owner",
  "crm.manual_prospect.field.next_action": "Next action",
  "crm.manual_prospect.field.due": "Due date",
  "crm.manual_prospect.field.notes": "Internal note",
  "crm.manual_prospect.ph.first_name": "e.g. Karim",
  "crm.manual_prospect.ph.last_name": "e.g. Benali",
  "crm.manual_prospect.ph.company": "e.g. Café du Port",
  "crm.manual_prospect.ph.country": "e.g. DZ",
  "crm.manual_prospect.ph.email": "contact@example.com",
  "crm.manual_prospect.ph.phone": "+213 555 12 34 56",
  "crm.manual_prospect.ph.source_detail": "e.g. CHR Algiers Trade Show 2026",
  "crm.manual_prospect.ph.assignee": "e.g. Taha",
  "crm.manual_prospect.ph.next_action": "e.g. Call back for a demo",
  "crm.manual_prospect.ph.notes": "Context of the meeting (internal only)",
  "crm.manual_prospect.ph.select": "Select…",
  "crm.manual_prospect.at_least_one": "At least one email or phone is required.",
  "crm.manual_prospect.open_existing": "Open the existing record",
  "crm.manual_prospect.submit": "Create prospect",
  "crm.manual_prospect.toast_created": "Prospect created. The client record is ready.",
  "crm.manual_prospect.err_first_name": "First name is required.",
  "crm.manual_prospect.err_origin": "Contact source is required.",
  "crm.manual_prospect.err_contact": "Enter at least one email or phone.",
  "crm.manual_prospect.err_email": "The email format is invalid.",
  "crm.manual_prospect.err_create_detail": "Cannot create: {detail}",
  "crm.manual_prospect.err_create": "Cannot create. Try again.",
  // __CRM_KEYS__
};
